import { render, staticRenderFns } from "./ServiceModalFilters.vue?vue&type=template&id=1465edbb&scoped=true&"
import script from "./ServiceModalFilters.vue?vue&type=script&lang=js&"
export * from "./ServiceModalFilters.vue?vue&type=script&lang=js&"
import style0 from "./ServiceModalFilters.vue?vue&type=style&index=0&id=1465edbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465edbb",
  null
  
)

export default component.exports